import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Space,
  Table,
  Pagination,
} from "@mantine/core";
import PageLayout from "../../../PageLayout";
import { EPageTitle, EButton, ETable, EModal, ETextInput, ETextArea } from "../../../libs/ui";
import { BsSearch } from "react-icons/bs";
import { DateInput } from "@mantine/dates";
import useAdminPatients from "./hooks/useAdminPatients";
import moment from "moment";
import axios from "axios";
import { API } from "../../../libs/data-access/constant";

export default function AdminPatientList() {
  const [searchParams] = useSearchParams()
  const center_name = searchParams.get("center_name");
  const center_state = searchParams.get("center_state");

  const {
    isLoading,
    totalPage,
    currentPage,
    setCurrentPage,
    payloadForAddFollowUpRequest,
    selectedPatient,
    isFollowUpModalOpen,
    patientList,
    filterValue,
    setFilterValue,
    setIsFollowUpModalOpen,
    setSelectedPatient,
    handleAddFollowUpRequest,
    handleUpdatePayload,
    handleGetPatientList,
    centerRoleID
  } = useAdminPatients();


  useEffect(() => {
    if (centerRoleID) {
      handleGetPatientList(1, centerRoleID, filterValue);
    }
  }, [filterValue, centerRoleID]);

  return (
    <PageLayout
      header={
        <EPageTitle
          title={`${center_name || ''} ${center_state ? ', ' + center_state : ''} Patient List`}
          description="List of all upcoming Tele Followup requests"
        />
      }
    >
      <div>
        {/* <Space h={"md"} /> */}
        <div className="flex justify-end mb-2">
          <ETextInput
            placeholder="Search"
            rightSection={
              <BsSearch
                className="cursor-pointer text-blue-600"
                size={22}
                onClick={() => { handleGetPatientList(1, centerRoleID) }}
              />}
            value={filterValue}
            onChange={(e) => setFilterValue(e?.target?.value)}
          />
        </div>
        {patientList?.length ? (
          <ETable
            hasEndButtons
            isLoading={isLoading}
          >
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Name</Table.Th>
                {/* <Table.Th>Father Name</Table.Th> */}
                <Table.Th>Mobile Number</Table.Th>
                <Table.Th>Alternate Mobile Number</Table.Th>
                <Table.Th>Secondary Alternate Mobile Number</Table.Th>
                <Table.Th>Address</Table.Th>
                <Table.Th>Last Followup date</Table.Th>
                <Table.Th></Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {patientList?.map((e) => (
                <Table.Tr key={e.center_id}>
                  <Table.Td className="link">
                    <div className="whitespace-nowrap">
                      {e?.first_name +
                        " " +
                        e?.last_name +
                        ` (${e?.age}, ${e?.gender?.charAt(0).toUpperCase()})`}
                    </div>
                  </Table.Td>
                  {/* <Table.Td>{e?.father_name}</Table.Td> */}
                  <Table.Td>{e?.primary_contact_no}</Table.Td>
                  <Table.Td>{e?.alternate_contact_no}</Table.Td>
                  <Table.Td>{e?.secondary_alternate_contact_no}</Table.Td>
                  <Table.Td>{e?.address}</Table.Td>
                  <Table.Td className="whitespace-nowrap">
                    {e?.followup_date
                      ? moment(e?.followup_date)?.format(
                        "DD MMM YYYY"
                      )
                      : "-"}
                  </Table.Td>
                  {/* <Table.Td>{e?.follow_ups[0]?.date_created ? e?.follow_ups[0]?.date_created : "-"}</Table.Td> */}
                  <Table.Td>
                    <EButton
                      variant="outline"
                      size={"sm"}
                      className=""
                      onClick={() => {
                        setSelectedPatient(e);
                        handleUpdatePayload("patient_id", e?.id);
                        handleUpdatePayload("followup_date", new Date());
                        handleUpdatePayload("remarks", "");
                        setIsFollowUpModalOpen(true);
                      }}
                    >
                      Tele Followup
                    </EButton>
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </ETable>
        ) : (
          <div className="flex justify-center items-center h-full w-full">
            <p className="mt-5 text-2xl">No data found</p>
          </div>
        )}
        <div className="flex justify-between pb-8">
          <div> </div>
          <Pagination
            size="sm"
            value={currentPage}
            onChange={(e) => {
              setCurrentPage(e)
              handleGetPatientList(e, centerRoleID)
            }}
            total={patientList[0]?.total_records ? Math.ceil(+patientList[0]?.total_records / 10) : 10}
          />
        </div>

      </div>
      <EModal
        isOpen={isFollowUpModalOpen}
        title={
          selectedPatient?.first_name +
          " " +
          selectedPatient?.last_name +
          (selectedPatient?.primary_contact_no
            ? " (" + selectedPatient?.primary_contact_no + ")"
            : "")
        }
        size="sm"
        setIsOpen={() => {
          setIsFollowUpModalOpen(false);
        }}
      >
        <div>
          <DateInput
            label="Date"
            value={payloadForAddFollowUpRequest?.followup_date}
            onChange={(e) => {
              handleUpdatePayload("followup_date", e);
            }}
          />
          <ETextArea
            value={payloadForAddFollowUpRequest?.remarks}
            onChange={(e) => {
              handleUpdatePayload("remarks", e?.target?.value);
            }}
            className="mt-5"
            label="Remarks"
          />
        </div>
        <EButton
          disabled={
            !payloadForAddFollowUpRequest?.remarks ||
            !payloadForAddFollowUpRequest?.followup_date
          }
          onClick={() => handleAddFollowUpRequest()}
          className="mt-5 w-full flex items-center justify-center"
        >
          Submit
        </EButton>
      </EModal>
    </PageLayout>
  );
}
